// A job is "connected" (and so unavailable to pick) when a Campaign, an
// Analysis (candidate batch), or a Workflow already holds it. The three id
// fields are populated server-side by `fetch-job-postings` / `fetch-kombo-jobs`
// (workflowId added in PAD-5496); the backend enforces the rule, this only
// surfaces it. Kept as one predicate so both job pickers stay in lockstep.
type JobOwnerSignals = {
  campaignId?: string | null;
  candidateBatchId?: string | null;
  workflowId?: string | null;
};

export const isJobConnectedToOwner = ({
  campaignId,
  candidateBatchId,
  workflowId
}: JobOwnerSignals): boolean =>
  !!campaignId || !!candidateBatchId || !!workflowId;
